export default __webpack_public_path__ + "static/media/kadickImage1.4ada08cc.png";